import { HiUsers } from "react-icons/hi2";

export const PartnersIcon = ({ width, height, color, ...props }) => (
  <HiUsers
    size={width || height || 25}
    color={color || "currentColor"}
    {...props}
  />
);
